'use strict';
import { newModalFromString } from '../components/modal';
import EmailDomainValidation from './emailDomainValidation';
import { checkNewAddressForm } from './address';
import AutoCompleteAddressLoqate from '../util/formAutocompleteAddress.js';

var addressHelpers = require('./address');
var formHelpers = require('./formErrors');
var debounce = require('lodash/debounce');

/**
 * Show, if it is a valid value, the estimated shipping date for the current order
 */

function updateEstimatedArriveTime () {
    let checkedMethodEstimatedArriveDays = $('input[name="dwfrm_shipping_shippingAddress_shippingMethodID"]:checked').data('day');
    let $shippingDateDiv = $('#estimated-arrive');
    let $shippingDateSpan = $('#estimated-arrive-days');
    if (checkedMethodEstimatedArriveDays == null) {
        $shippingDateDiv.hide();
        $shippingDateSpan.text(checkedMethodEstimatedArriveDays);
    } else {
        $shippingDateDiv.show();
        $shippingDateSpan.text(checkedMethodEstimatedArriveDays);
    }
}

$(document).ready(updateEstimatedArriveTime);

/**
 * updates the shipping address selector within shipping forms
 * @param {Object} productLineItem - the productLineItem model
 * @param {Object} shipping - the shipping (shipment model) model
 * @param {Object} order - the order model
 * @param {Object} customer - the customer model
 */
function updateShippingAddressSelector (productLineItem, shipping, order, customer) {
    var uuidEl = $('input[value=' + productLineItem.UUID + ']');
    var shippings = order.shipping;

    var form;
    var $shippingAddressSelector;
    var hasSelectedAddress = false;

    if (uuidEl && uuidEl.length > 0) {
        form = uuidEl[0].form;
        $shippingAddressSelector = $('.addressSelector', form);
    }

    if ($shippingAddressSelector && $shippingAddressSelector.length === 1) {
        $shippingAddressSelector.empty();
        // Add New Address option
        $shippingAddressSelector.append(addressHelpers.methods.optionValueForAddress(
            null,
            false,
            order));
        // Separator -
        $shippingAddressSelector.append(addressHelpers.methods.optionValueForAddress(
            order.resources.shippingAddresses, false, order, { className: 'multi-shipping' }
        ));
        shippings.forEach(function (aShipping) {
            var isSelected = shipping.UUID === aShipping.UUID;
            hasSelectedAddress = hasSelectedAddress || isSelected;
            $shippingAddressSelector.append(
                addressHelpers.methods.optionValueForAddress(aShipping, isSelected, order,
                    { className: 'multi-shipping' }
                )
            );
        });
        if (customer.addresses && customer.addresses.length > 0) {
            $shippingAddressSelector.append(addressHelpers.methods.optionValueForAddress(
                order.resources.accountAddresses, false, order));
            customer.addresses.forEach(function (address) {
                var isSelected = shipping.matchingAddressId === address.ID;
                $shippingAddressSelector.append(
                    addressHelpers.methods.optionValueForAddress({
                        UUID: 'ab_' + address.ID,
                        shippingAddress: address
                    }, isSelected, order)
                );
            });
        }
    }

    if (!hasSelectedAddress) {
        // show
        $(form).addClass('hide-details');
    } else {
        $(form).removeClass('hide-details');
    }

    $('body').trigger('shipping:updateShippingAddressSelector', {
        productLineItem: productLineItem,
        shipping: shipping,
        order: order,
        customer: customer
    });
}

/**
 * updates the shipping address form values within shipping forms
 * @param {Object} shipping - the shipping (shipment model) model
 */
function updateShippingAddressFormValues (shipping, customer, address, step) {
    var selectedShippingMethodCourier = shipping.selectedShippingMethod.shippingType.value === 'courier';
    if ($('.addressSelector input[type="radio"]:checked').length && selectedShippingMethodCourier && shipping.shippingAddress && step === 'selectShippingMethod') {
        shipping.shippingAddress.address1 = $('.addressSelector input[type="radio"]:checked').attr('data-address1');
        shipping.shippingAddress.city = $('.addressSelector input[type="radio"]:checked').attr('data-city');
        shipping.shippingAddress.postalCode = $('.addressSelector input[type="radio"]:checked').attr('data-postal-code');
        shipping.shippingAddress.stateCode = $('.addressSelector input[type="radio"]:checked').attr('data-state-code');
    }
    var addressObject = $.extend({}, shipping.shippingAddress);

    if (!addressObject) {
        addressObject = {
            firstName: null,
            lastName: null,
            address1: null,
            address2: null,
            city: null,
            postalCode: null,
            stateCode: null,
            countryCode: null,
            phone: null,
            addressId: null
        };
    }

    addressObject.isGift = shipping.isGift;
    addressObject.giftMessage = shipping.giftMessage;

    $('input[value=' + shipping.UUID + ']').each(function (formIndex, el) {
        var form = el.form;
        if (!form) return;
        var countryCode = addressObject.countryCode;

        $('input[name$=_addressId]', form).val(addressObject.addressId || shipping.matchingAddressId);
        $('input[name$=_firstName]', form).val(addressObject.firstName || (customer && 'profile' in customer && customer.profile && 'firstName' in customer.profile ? customer.profile.firstName || '' : ''));
        $('input[name$=_lastName]', form).val(addressObject.lastName || (customer && 'profile' in customer && customer.profile && 'lastName' in customer.profile ? customer.profile.lastName || '' : ''));
        $('input[name$=_address1]', form).val(addressObject.address1);
        $('input[name$=_address2]', form).val(addressObject.address2);
        $('input[name$=_city]', form).val(addressObject.city);
        $('input[name$=_postalCode]', form).val(addressObject.postalCode);
        $('select[name$=_stateCode],input[name$=_stateCode]', form)
            .val(addressObject.stateCode);

        if (countryCode && typeof countryCode === 'object') {
            $('select[name$=_country]', form).val(addressObject.countryCode.value);
        } else {
            if (address) {
                $('select[name$=_country]', form).val(address.countryCode);
            }
        }

        // $('input[name$=_phone]', form).val(addressObject.phone);

        $('input[name$=_isGift]', form).prop('checked', addressObject.isGift);
        $('textarea[name$=_giftMessage]', form).val(addressObject.isGift && addressObject.giftMessage ? addressObject.giftMessage : '');
    });

    $('body').trigger('shipping:updateShippingAddressFormValues', { shipping: shipping });
}

/**
 * update the list of states and postal code regex in shipping address
 * @param {Object} data
 * @param {Object[]} statesOptions the new list of states
 * @param {String} postalCodeRegex new postalCode regex
 */
function updateShippingStatesAndPostalCode (data) {
    $('#shippingState').find('option').remove();
    var stateOptions = '';
    data.statesOptions.forEach(state => {
        stateOptions += `<option id="${state.id}" value="${state.value}">${state.label}</option>`;
    });
    $('#shippingState').append(stateOptions);
    $('#shippingState').trigger('chosen:updated');
    $('#shippingZipCode').prop('pattern', data.postalCodeRegex);
}

/**
 * Update list of available shipping methods whenever user modifies shipping address details.
 * @param {jQuery} $shippingForm - current shipping form
 */
function updateShippingMethodList ($shippingForm) {
    // delay for autocomplete!
    setTimeout(function () {
        var $shippingMethodList = $shippingForm.find('.shipping-method-list');
        var urlParams = addressHelpers.methods.getAddressFieldsFromUI($shippingForm);
        var shipmentUUID = $shippingForm.find('[name=shipmentUUID]').val();
        var url = $shippingMethodList.data('actionUrl');
        urlParams.shipmentUUID = shipmentUUID;

        $.spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: urlParams,
            success: function (data) {
                if (data.error) {
                    window.location.href = data.redirectUrl;
                } else {
                    $('body').trigger('checkout:updateCheckoutView',
                        {
                            order: data.order,
                            customer: data.customer,
                            options: { keepOpen: true }
                        });

                    $shippingMethodList.spinner().stop();
                }
            }
        });
    }, 300);
}

/**
 * updates the order shipping summary for an order shipment model
 * @param {Object} shipping - the shipping (shipment model) model
 * @param {Object} order - the order model
 */
function updateShippingSummaryInformation (shipping, order) {
    $('[data-shipment-summary=' + shipping.UUID + ']').each(function (i, el) {
        var $container = $(el);
        var $shippingAddressLabel = $container.find('.shipping-addr-label');
        var $addressContainer = $container.find('.address-summary');
        var $shippingPhone = $container.find('.shipping-phone');
        var $shippingEmail = $container.find('.shipping-email');
        var $methodTitle = $container.find('.shipping-method-title');
        var $methodArrivalTime = $container.find('.shipping-method-arrival-time');
        var $methodPrice = $container.find('.shipping-method-price');
        var $methodAnalytics = $container.find('.shipping-method-type');
        var $shippingSummaryLabel = $container.find('.shipping-method-label');
        var $summaryDetails = $container.find('.row.summary-details');
        var giftMessageSummary = $container.find('.gift-summary');
        var $storeName = $container.find('.address-summary-store-name');

        var address = shipping.shippingAddress;
        var selectedShippingMethod = shipping.selectedShippingMethod;
        var isGift = shipping.isGift;

        addressHelpers.methods.populateAddressSummary($addressContainer, address);

        if (address && address.phone) {
            $shippingPhone.text(address.phone);
        } else {
            $shippingPhone.empty();
        }
        if (order && order.orderEmail) {
            $shippingEmail.text(order.orderEmail);
        } else {
            $shippingEmail.empty();
        }

        if (selectedShippingMethod) {
            $('body').trigger('shipping:updateAddressLabelText',
                { selectedShippingMethod: selectedShippingMethod, resources: order.resources, shippingAddressLabel: $shippingAddressLabel });
            $shippingAddressLabel.text(order.resources.shippingAddress);
            $shippingSummaryLabel.show();
            $summaryDetails.show();
            var shippingName = 'home_standard';
            if (selectedShippingMethod.estimatedArriveDaysInterval) {
                $methodTitle.text(selectedShippingMethod.shippingMethodRecapTitle + ' ' + selectedShippingMethod.estimatedArriveDaysInterval);
            } else {
                $methodTitle.text(selectedShippingMethod.shippingMethodRecapTitle);
            }
            if (selectedShippingMethod.estimatedArriveDays) {
                $methodArrivalTime.text(selectedShippingMethod.estimatedArriveDays);
            } else {
                $methodArrivalTime.text('');
            }
            $storeName.text('').hide();
            if (selectedShippingMethod.storePickupEnabled) {
                $container.find('.address-summary-courier').hide();
                $container.find('.address-summary-other').show();
                shippingName = 'shop';
                // Fill store name on order summary with selected store name
                $storeName.text($('.shipping-section .js-store-name').first().text()).show();
            } else if (selectedShippingMethod.pointPickupEnabled) {
                $container.find('.address-summary-courier').hide();
                $container.find('.address-summary-other').show();
                shippingName = 'pickup_point';
            } else {
                if (selectedShippingMethod.isExpressShipping) {
                    shippingName = 'home_express';
                }
                $container.find('.address-summary-courier').show();
                $container.find('.address-summary-other').hide();
            }
            $methodAnalytics.text(shippingName);
            updateEstimatedArriveTime();
        }

        if (isGift) {
            giftMessageSummary.find('.gift-message-summary').text(shipping.giftMessage);
            giftMessageSummary.removeClass('d-none');
        } else {
            giftMessageSummary.addClass('d-none');
        }
    });

    $('body').trigger('shipping:updateShippingSummaryInformation', { shipping: shipping, order: order });
}

/**
 * Update the read-only portion of the shipment display (per PLI)
 * @param {Object} productLineItem - the productLineItem model
 * @param {Object} shipping - the shipping (shipment model) model
 * @param {Object} order - the order model
 * @param {Object} [options] - options for updating PLI summary info
 * @param {Object} [options.keepOpen] - if true, prevent changing PLI view mode to 'view'
 */
function updatePLIShippingSummaryInformation (productLineItem, shipping, order, options) {
    var keepOpen = options && options.keepOpen;

    var $pli = $('input[value=' + productLineItem.UUID + ']');
    var form = $pli && $pli.length > 0 ? $pli[0].form : null;

    if (!form) return;

    var $viewBlock = $('.view-address-block', form);

    var hasAddress = !!shipping.shippingAddress;
    var address = shipping.shippingAddress || {};
    var selectedMethod = shipping.selectedShippingMethod;

    var nameLine = address.firstName ? address.firstName + ' ' : '';
    if (address.lastName) nameLine += address.lastName;

    var address1Line = address.address1;
    var address2Line = address.address2;

    var phoneLine = address.phone;

    var shippingCost = selectedMethod ? selectedMethod.shippingCost : '';
    var methodNameLine = selectedMethod ? selectedMethod.displayName : '';
    var methodArrivalTime = selectedMethod && selectedMethod.estimatedArrivalTime
        ? '(' + selectedMethod.estimatedArrivalTime + ')'
        : '';

    var tmpl = $('#pli-shipping-summary-template').clone();

    $('.ship-to-name', tmpl).text(nameLine);
    $('.ship-to-address1', tmpl).text(address1Line);
    $('.ship-to-address2', tmpl).text(address2Line);
    $('.ship-to-city', tmpl).text(address.city);
    if (address.stateCode) {
        $('.ship-to-st', tmpl).text(address.stateCode);
    }
    $('.ship-to-zip', tmpl).text(address.postalCode);
    $('.ship-to-phone', tmpl).text(phoneLine);

    if (!address2Line) {
        $('.ship-to-address2', tmpl).hide();
    }

    if (!phoneLine) {
        $('.ship-to-phone', tmpl).hide();
    }

    if (shipping.selectedShippingMethod) {
        $('.display-name', tmpl).text(methodNameLine);
        $('.arrival-time', tmpl).text(methodArrivalTime);
        $('.price', tmpl).text(shippingCost);
    }

    if (shipping.isGift) {
        $('.gift-message-summary', tmpl).text(shipping.giftMessage);
        var shipment = $('.gift-message-' + shipping.UUID);
        $(shipment).val(shipping.giftMessage);
    } else {
        $('.gift-summary', tmpl).addClass('d-none');
    }
    // checking h5 title shipping to or pickup
    var $shippingAddressLabel = $('.shipping-header-text', tmpl);
    $('body').trigger('shipping:updateAddressLabelText',
        { selectedShippingMethod: selectedMethod, resources: order.resources, shippingAddressLabel: $shippingAddressLabel });

    $viewBlock.html(tmpl.html());

    $('body').trigger('shipping:updatePLIShippingSummaryInformation', {
        productLineItem: productLineItem,
        shipping: shipping,
        order: order,
        options: options
    });
    if (!keepOpen) {
        if (hasAddress) {
            $viewBlock.parents('[data-view-mode]').attr('data-view-mode', 'view');
        } else {
            $viewBlock.parents('[data-view-mode]').attr('data-view-mode', 'enter');
        }
    }
}

/**
 * Update the hidden form values that associate shipping info with product line items
 * @param {Object} productLineItem - the productLineItem model
 * @param {Object} shipping - the shipping (shipment model) model
 */
function updateProductLineItemShipmentUUIDs (productLineItem, shipping) {
    $('input[value=' + productLineItem.UUID + ']').each(function (key, pli) {
        var form = pli.form;
        $('[name=shipmentUUID]', form).val(shipping.UUID);
        $('[name=originalShipmentUUID]', form).val(shipping.UUID);

        $(form).closest('.card').attr('data-shipment-uuid', shipping.UUID);
    });

    $('body').trigger('shipping:updateProductLineItemShipmentUUIDs', {
        productLineItem: productLineItem,
        shipping: shipping
    });
}

/**
 * Update the shipping UI for a single shipping info (shipment model)
 * @param {Object} shipping - the shipping (shipment model) model
 * @param {Object} order - the order/basket model
 * @param {Object} customer - the customer model
 * @param {Object} [options] - options for updating PLI summary info
 * @param {Object} [options.keepOpen] - if true, prevent changing PLI view mode to 'view'
 */
function updateShippingInformation (shipping, order, customer, options, address, selectShippingMethod) {
    // First copy over shipmentUUIDs from response, to each PLI form
    order.shipping.forEach(function (aShipping) {
        aShipping.productLineItems.items.forEach(function (productLineItem) {
            updateProductLineItemShipmentUUIDs(productLineItem, aShipping);
        });
    });
    updateShippingAddressFormValues(shipping, customer, address, selectShippingMethod);
    updateShippingSummaryInformation(shipping, order);

    // And update the PLI-based summary information as well
    shipping.productLineItems.items.forEach(function (productLineItem) {
        updateShippingAddressSelector(productLineItem, shipping, order, customer);
        updatePLIShippingSummaryInformation(productLineItem, shipping, order, options);
    });

    $('body').trigger('shipping:updateShippingInformation', {
        order: order,
        shipping: shipping,
        customer: customer,
        options: options,
        step: selectShippingMethod
    });
}

/**
 * Update the checkout state (single vs. multi-ship) via Session.privacy cache
 * @param {Object} order - checkout model to use as basis of new truth
 */
function updateMultiShipInformation (order) {
    var $checkoutMain = $('#checkout-main');
    var $checkbox = $('[name=usingMultiShipping]');
    var $submitShippingBtn = $('button.submit-shipping');

    if (order.usingMultiShipping) {
        // shippingState.changeState({ multiship: order.usingMultiShipping, collapsed: true });
        $checkoutMain.addClass('multi-ship');
        $checkbox.prop('checked', true);
    } else {
        $checkoutMain.removeClass('multi-ship');
        $checkbox.prop('checked', null);
        $submitShippingBtn.prop('disabled', null);
        // shippingState.changeState({ collapsed: true });
    }
}

/**
 * Handle response from the server for valid or invalid form fields.
 * @param {Object} defer - the deferred object which will resolve on success or reject.
 * @param {Object} data - the response data with the invalid form fields or
 *  valid model data.
 */

(function () {
    var lastSelectedAddress = null;

    $('body').on('click change', '.shipping-form .addressSelector input[type="radio"]', function () {
        lastSelectedAddress = $(this).closest('.addressSelector');
    });

    window.addressTracker = {
        getLastSelected: function () {
            return lastSelectedAddress;
        }
    };
})();

function shippingFormResponse (defer, data) {
    var isMultiShip = $('#checkout-main').hasClass('multi-ship');
    var formSelector = isMultiShip
        ? '.multi-shipping .active form'
        : '.single-shipping form';

    // highlight fields with errors
    if (data.error) {
        if (data.fieldErrors.length) {
            var hasShippingFieldError = data.fieldErrors.length && data.fieldErrors[0] && Object.keys(data.fieldErrors[0]).length > 0;

            if (hasShippingFieldError) {
                var $selectedAddress = window.addressTracker.getLastSelected() ||
                    $('label.addressSelector input[type="radio"]:checked').closest('.addressSelector');

                if ($selectedAddress.length) {
                    var $openBtn = $selectedAddress.find('.js-show-details:visible').first();
                    if ($openBtn.length) {
                        $openBtn.trigger('click');
                    } else {
                        $selectedAddress.attr('data-address-mode', 'change');
                        $selectedAddress.closest('[data-view-mode]').attr('data-view-mode', 'edit');
                        $selectedAddress.find('.shipping-address-block').removeClass('hidden');
                    }
                    if (data.fieldErrors[0]) {
                        formHelpers.loadFormErrors(formSelector, data.fieldErrors[0]);
                    }
                }
            }
            defer.reject(data);
        }

        if (data.cartError) {
            window.location.href = data.redirectUrl;
            defer.reject();
        }
    } else {
        //
        // Populate the Address Summary
        //

        let error = false;
        if (data && data.order && data.order.shipping && data.order.shipping[0] && data.order.shipping[0].selectedShippingMethod) {
            let selectedShippingMethod = data.order.shipping[0].selectedShippingMethod;
            if ((selectedShippingMethod.shippingType && selectedShippingMethod.shippingType.value === 'pickupInPost') ||
                (selectedShippingMethod.shippingMethodType && (selectedShippingMethod.shippingMethodType === 'DPDPUP' || selectedShippingMethod.shippingMethodType === 'DHLLocationPUP' || selectedShippingMethod.shippingMethodType === 'PPLPUP' || selectedShippingMethod.shippingMethodType === 'CLSS' || selectedShippingMethod.shippingMethodType === 'SPS'))) {
                if ((!data.pickUpPointName)) {
                    error = true;
                }
            }
        }
        if (data && data.order && data.addressValidation && !data.addressValidation.success && data.addressValidation.loqateEnabled) {
            var shippingAddress = data.order.shipping && data.order.shipping[0] && data.order.shipping[0].shippingAddress ? data.order.shipping[0].shippingAddress : {};
            showAddressValidationSuggestion(shippingAddress, data.addressValidation.suggestedMatch);
            $('.shipping-form').attr('data-checkout-stage-to-validate', 'true');
        }
        $('.shipping-form').removeAttr('data-shipping-suggestion-skip data-shipping-suggestion-visible');
        $('#addressInsertedByUserRecurrent').remove();
        $('#addressSuggestedRecurrent').remove();
        if (!error) {
            $('body').trigger('checkout:updateCheckoutView', { order: data.order, customer: data.customer, addressValidation: data.addressValidation });

            defer.resolve(data);
        } else {
            defer.reject();
        }
    }
}

/**
 * Does Ajax call to trigger multishipping
 * @param {boolean} checked - is multi shipping checked
 */
function toggleMultiShip (checked) {
    var url = $('.shipping-nav form').attr('action');
    $.spinner().start();
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: {
            usingMultiShip: !!checked
        },
        success: function (data) {
            if (data.error) {
                window.location.href = data.redirectUrl;
            } else {
                $('body').trigger('checkout:updateCheckoutView',
                    { order: data.order, customer: data.customer });
            }
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Does Ajax call to create a server-side shipment w/ pliUUID & URL
 * @param {string} url - string representation of endpoint URL
 * @param {Object} shipmentData - product line item UUID
 * @returns {Object} - promise value for async call
 */
function createNewShipment (url, shipmentData) {
    $.spinner().start();
    return $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: shipmentData
    });
}

function clearInputFields () {
    const shippingForm = $('#shippingAddressForm');
    $('input[name$=_address1]', shippingForm).val('');
    $('input[name$=_houseNumber]', shippingForm).val('');
    $('input[name$=_address2]', shippingForm).val('');
    $('input[name$=_city]', shippingForm).val('');
    $('input[name$=_postalCode]', shippingForm).val('');
    const billingForm = $('.billingFormGroup');
    if (billingForm) {
        $('input[name$=_address1]', billingForm).val('');
        $('input[name$=_address2]', billingForm).val('');
        $('input[name$=_city]', billingForm).val('');
        $('input[name$=_postalCode]', billingForm).val('');
    }
}

function hideAddressFormForGiftcard () {
    $('input[name$=storeId]').remove();
    $('.shipment-selector-block').hide();
    // $('#shippingAddressForm').hide();
    const form = $('#shippingAddressForm');
    $('input[name$=_firstName]', form).val('');
    $('input[name$=_lastName]', form).val('');
    $('input[name$=_address1]', form).hide();
    $('input[name$=_address2]', form).hide();
    $('#shipping_more_info', form).hide();
    $('.shipping-form').attr('data-shipping-suggestion-visible', 'false');
    $('input[name$=_city]', form).hide();
    $('input[name$=_postalCode]', form).hide();
    $('select[name$=_stateCode],input[name$=_stateCode]', form)
        .hide();
    $('.form-field-hidden', form).hide();
    $('.js-state-info-icon', form).hide();
    $('.form-control-label-zip', form).hide();
    $('.form-control-label-country', form).hide();
    $('.form-control-label-city', form).hide();
    $('.form-control-label-address-one', form).hide();
    $('.form-control-label-address-two', form).hide();

    $('select[name$=_country]', form).hide();
    $('input[name$=_phone]', form).val('');
    $('.shipping-address-subtitle', form).hide();
    $('.shipping-address-subtitle-electronic', form).show();

    // For UA
    $('input[name$=_houseNumber]', form).hide();
    $('input[name$=_flatNumber]', form).hide();
    $('input[name$=_orderNotes]', form).hide();
    $('label[for="shippingHouseNumber"]', form).hide();
    $('.info-icon-position-right', form).hide();

    // Hide the fake dropdown
    $('.chosen-container', form).hide();
}

function hideAddressForm (typeMethod, step) {
    if (typeMethod !== 'pickup') {
        $('input[name$=storeId]').remove();
        $('.shipping-form .js-select-store').show();
        $('.shipping-form .js-change-store').hide();
        $('.shipping-form .selectedStoreRecap').hide();
        $('.express-flow-modal-custom .selectedStoreRecap').hide();
    }

    if (typeMethod !== 'pup' || step === 'selectShippingMethod') {
        // Remove previous selection for pickup point
        $('.shipping-form #pickUpPointNumber').remove();
        $('.shipping-form #pickUpPointName').remove();
        $('.shipping-form #pickUpPointAddress1').remove();
        $('.shipping-form #pickUpPointCity').remove();
        $('.shipping-form #pickUpPointPostalCode').remove();
        // $('.shipment-selector-block').hide();
        if (step === 'partialStep') {
            $('.shipping-form .selectedPickupPointRecap').hide();
        } else if (step === 'selectShippingMethod') {
            $('.selectedPickupPointRecap').hide();
            $('.shipping-form .js-select-point').attr('style', '');
            $('.shipping-form .js-change-point').attr('style', 'display: none');
            $('.selectedSwissPostPickupPointRecap').hide();
            $('.shipping-form .js-select-swiss-point').attr('style', '');
	        $('.shipping-form .js-change-swiss-point').attr('style', 'display: none');
            $('.selectedExpressOnePickupPointRecap').addClass('hide');
            $('.shipping-form .js-select-eo-pup').removeClass('hide');
            $('.selectedNovaPoshtaPickupRecap').addClass('hide');
            $('.shipping-form .np-first-selection-btn').removeClass('hide');
            $('.js-select-pickup-btn').removeClass('hide');
            $('.js-select-pickup-recap').addClass('hide');
        }
    }
    // $('#shippingAddressForm').hide();
    $('.shipment-selector-block').hide();
    const form = $('#shippingAddressForm');
    $('input[name$=_addressId]', form).val('');
    // $('input[name$=_firstName]', form).val('');
    // $('input[name$=_lastName]', form).val('');
    $('input[name$=_address1]', form).hide();
    $('input[name$=_address2]', form).hide();
    $('#shipping_more_info', form).hide();
    $('.shipping-form').attr('data-shipping-suggestion-visible', 'false');
    $('input[name$=_city]', form).hide();
    $('input[name$=_postalCode]', form).hide();
    $('select[name$=_stateCode],input[name$=_stateCode]', form)
        .hide();
    $('.form-field-hidden', form).hide();
    $('.js-state-info-icon', form).hide();
    $('.form-control-label-zip', form).hide();
    $('.form-control-label-country', form).hide();
    $('.form-control-label-city', form).hide();
    $('.form-control-label-address-one', form).hide();
    $('.form-control-label-address-two', form).hide();

    $('select[name$=_country]', form).hide();
    $('.form-control-label-select[for="shippingState"]', form).hide();
    $('.form-control-label-select[for="shippingCountry"]', form).hide();
    $('.js-order-shipping-address-title', form).addClass('saved-address-block');
    // $('input[name$=_phone]', form).val('');
    if (typeMethod === 'electronic') {
        $('.shipping-address-subtitle', form).hide();
        $('.shipping-address-subtitle-electronic', form).show();
    } else if (typeMethod === 'pup') {
        $('.shipping-address-subtitle', form).hide();
        $('.shipping-address-subtitle-pup', form).show();
    } else {
        $('.shipping-address-subtitle', form).hide();
        $('.shipping-address-subtitle-pickup', form).show();
    }

    // For UA
    $('input[name$=_houseNumber]', form).hide();
    $('input[name$=_flatNumber]', form).hide();
    $('input[name$=_orderNotes]', form).hide();
    $('label[for="shippingHouseNumber"]', form).hide();
    $('.info-icon-position-right', form).hide();

    $('.chosen-container', form).hide();

}

function showAddressForm (step) {
    const form = $('#shippingAddressForm');
    $('#shipping_more_info', form).show();
    if ($('.shipping-form').attr('data-shipping-suggestion-enabled') === 'true' && step !== false) {
        if ($('.addressSelector input[type="radio"]:checked').length > 0) {
            $('.shipping-form').attr('data-shipping-suggestion-visible', 'false');
        } else {
            $('.shipping-form').attr('data-shipping-suggestion-visible', 'true');
        }
    }
    $('input[name$=_address1]', form).show();
    $('input[name$=_address2]', form).show();
    $('input[name$=_city]', form).show();
    $('input[name$=_postalCode]', form).show();
    $('select[name$=_stateCode],input[name$=_stateCode]', form).show();
    $('.form-field-hidden', form).show();
    $('.js-state-info-icon', form).show();
    $('.form-control-label-zip', form).show();
    $('.form-control-label-country', form).show();
    $('.form-control-label-city', form).show();
    $('.form-control-label-address-one', form).show();
    $('.form-control-label-address-two', form).show();
    $('select[name$=_country]', form).show();
    $('.form-control-label-select[for="shippingState"]', form).show();
    $('.form-control-label-select[for="shippingCountry"]', form).show();
    $('#shippingAddressForm').show();
    $('.shipment-selector-block').show();
    $('.chosen-container', form).show();
    if (Foundation.MediaQuery.atLeast('medium') && ($('#shippingState_chosen').length > 0 || $('#shippingCountry_chosen').length > 0)) {
        $('#shippingState').hide();
        $('#shippingCountry').hide();
    }

    // Remove previous selection for pickup point
    $('body').remove('.shipping-form #pickUpPointNumber');
    $('body').remove('.shipping-form #pickUpPointName');
    $('body').remove('.shipping-form #pickUpPointAddress1');
    $('body').remove('.shipping-form #pickUpPointCity');
    $('body').remove('.shipping-form #pickUpPointPostalCode');

    $('input[name$=storeId]').remove();
    $('#selectedStoreRecap').hide();
    $('#selectedPickupRecap').addClass('hide');
    $('.shipping-form .selectedStoreRecap').hide();
    $('.express-flow-modal-custom .selectedStoreRecap').hide();
    $('.shipping-form .js-select-store').css('display', 'inline-block');
    $('.shipping-form .js-change-store').hide();
    $('.selectedExpressOnePickupPointRecap').addClass('hide');
    $('.shipping-form .js-select-eo-pup').removeClass('hide');
    $('.selectedNovaPoshtaPickupRecap').addClass('hide');
    $('.shipping-form .np-first-selection-btn').removeClass('hide');
    $('.js-select-pickup-btn').removeClass('hide');
    $('.js-select-pickup-recap').addClass('hide');

    $('.shipping-address-subtitle', form).hide();
    $('.shipping-address-subtitle-courier', form).show();
    $('.js-order-shipping-address-title', form).removeClass('saved-address-block');

    // For UA
    $('input[name$=_houseNumber]', form).show();
    $('input[name$=_flatNumber]', form).show();
    $('input[name$=_orderNotes]', form).show();
    $('label[for="shippingHouseNumber"]', form).show();
    $('.info-icon-position-right', form).show();
}

function setMandatoryBilling () {
    if ($('.js-mandatory-billing-flow').length > 0) {
        var $billingCheckbox = $('#billInDifferentAddress');
        if ($billingCheckbox.length > 0) {
            $billingCheckbox.prop('checked', true);
            $billingCheckbox.val('1');
        }
        $('.billingFormGroup').removeClass('hide');
    }
    $('.billInDifferentAddress').addClass('hide');
}

function resetBillingState () {
    if ($('.js-mandatory-billing-flow').length > 0) {
        var $billingCheckbox = $('#billInDifferentAddress');
        if ($billingCheckbox.length > 0) {
            $billingCheckbox.prop('checked', false);
            $billingCheckbox.val('0');
            $('.billingFormGroup').addClass('hide');
        }
    }
    $('.billInDifferentAddress').removeClass('hide');
}

/**
 * Hide/Show form based on selected shipping method
 * @param {Object} shipping - shipping object with custom attribute (pup and store pickup)
 */
function shippingSelectionResponse (data) {
    var shipping = data.shipping;
    $('.next-step-button').find('.submit-shipping').prop('disabled', false);
    $('.js-expressButtonContinue').prop('disabled', false);
    $('#expressButtonModal').attr('data-modal-stage', 'shipping');
    if (shipping.storePickupEnabled) {
        hideAddressForm('pickup', 'partialStep');
        setMandatoryBilling();
    } else if (shipping.pointPickupEnabled) {
        hideAddressForm('pup', 'partialStep');
        setMandatoryBilling();
    } else if (shipping.isElectronicShipping) {
        hideAddressFormForGiftcard();
        setMandatoryBilling();
    } else {
        showAddressForm();
        resetBillingState();
        checkNewAddressForm();
    }
    $('body').trigger('shipping:selectShippingInformation');
}

function checkIfDeliveryAddressShouldBeHidden () {
    if ($('[data-pickup="true"]:checked').length || $('[data-iselectronic="true"]:checked').length || $('[data-pickup-point="true"]:checked').length) {
        setMandatoryBilling();
        if ($('[data-pickup="true"]:checked').length) {
            hideAddressForm('pickup');
        } else if ($('[data-pickup-point="true"]:checked').length) {
            hideAddressForm('pup');
        } else {
            hideAddressForm('electronic');
        }
    }
}

/**
 * Does Ajax call to select shipping method
 * @param {string} url - string representation of endpoint URL
 * @param {Object} urlParams - url params
 */
function selectShippingMethodAjax (url, urlParams, el) {
    $.spinner().start();
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: urlParams
    })
        .done(function (data) {
            if (data.error) {
                window.location.href = data.redirectUrl;
            } else {
                if (data.shouldUpdateShippingFormValidation) {
                    updateShippingStatesAndPostalCode(data.newShippingFormData);
                }
                $('body').trigger('checkout:updateCheckoutView',
                    {
                        order: data.order,
                        customer: data.customer,
                        action: data.action,
                        options: {
                            keepOpen: true,
                            selectMethodStep: true
                        },
                        urlParams: urlParams,
                        step: 'selectShippingMethod'
                    }
                );
                $('body').trigger('checkout:postUpdateCheckoutView',
                    {
                        el: undefined
                    }
                );
            }
            $.spinner().stop();
        })
        .fail(function () {
            $.spinner().stop();
        });
}

/**
 * Check if the express button should be enabled after change shipping method
 * @param {Object} shipment
 * @param {Object} data - basket
*/
function enableExpressButton (shipment, data) {
    var expressMethodEnabled = true;
    if (data.order && data.order.items) {
        const orderItems = data.order.items.items;
        for (let item of orderItems) {
            if (!item.wrappedQuantity || item.wrappedQuantity === 0) {
                $('.js-gifting-container-' + item.UUID).addClass('hide');
            } else {
                expressMethodEnabled = false;
                $('.js-gifting-container-' + item.UUID).removeClass('hide');
                $('.js-wrapped-quantity-' + item.UUID).html(item.wrappedQuantity);
            }
            if (item.isGiftKit) {
                expressMethodEnabled = false;
            }
        }
    }
    if (expressMethodEnabled) {
        $('.js-paypal-container').removeClass('disabled');
        $('.js-amazon-pay-container').removeClass('disabled');
        $('.js-google-pay-container').removeClass('disabled');
        // if the shipping method selected is not the default courier, applePay button should be disabled
        if (shipment.selectedShippingMethod.isApplePayEnabled) {
            $('.js-apple-pay-container:not(.js-apple-pay-standard-container)').removeClass('disabled');
        } else {
            $('.js-apple-pay-container:not(.js-apple-pay-standard-container)').addClass('disabled');
        }
    } else {
        $('.js-paypal-container').addClass('disabled');
        $('.js-apple-pay-container:not(.js-apple-pay-standard-container)').addClass('disabled');
        $('.js-amazon-pay-container').addClass('disabled');
        $('.js-google-pay-container').addClass('disabled');
    }
}

/**
 * Does Ajax call to retrieve suggested addresses from loqate service
 * @param {Object} scope - Search field DOM element
 */
function getSuggestedAddress (scope, addressId) {
    const numberOfChar = $('#shipping_address_autocomplete').data('number-of-char');
    if ($('#shippingAddressAuto').val().length >= numberOfChar) {
        let endpoint = $('#shippingAddressAuto').data('shipping-find-url');
        let requestData = {
            text: $('#shippingAddressAuto').val()
        };

        if (addressId) {
            requestData.container = addressId;
        }

        $.spinner().start();
        $.ajax({
            url: endpoint,
            method: 'GET',
            data: requestData
        })
            .done(function (result) {
                AutoCompleteAddressLoqate.autocomplete(document.getElementById('shippingAddressAuto'), result.data || []);
                $.spinner().stop();
            })
            .fail(function () {
                $.spinner().stop();
                $('#shipping_more_info').attr('style', '');
                $('.shipping-form').attr('data-shipping-suggestion-visible', 'false');
            });
    }
}

/**
 * Does Ajax call to retrieve suggested addresses from loqate service
 * @param {Object} scope - Search field DOM element
 */
function retrieveAddress (id) {
    let endpoint = $('.shippingAddressAuto').data('shipping-retrieve-url');
    $.spinner().start();
    $.ajax({
        url: endpoint,
        method: 'GET',
        data: {
            id: id
        }
    })
        .done(function (result) {
            if (result.success && result.data && result.data.length > 0) {
                var data = result.data[0];
                if ($('#checkout-main').length > 0) {
                    $('.addressSelector input[type="radio"]#new-address:checked').length > 0
                    const shippingForm = $('.addressSelector input[type="radio"]#new-address:checked').length > 0 ?
                        $('.internal-container.add-new-address') :
                        $('#shippingAddressForm');
                    $('#shippingAddressOne', shippingForm).val(data.Line1);
                    $('#shippingAddressTwo', shippingForm).val(data.Line2 || data.Line3 || '');
                    $('#shippingAddressCity', shippingForm).val(data.City);
                    $('#shippingZipCode', shippingForm).val(data.PostalCode);
                    $('#shippingState', shippingForm).val(data.Province).trigger('chosen:updated');
                    if ($('.addressSelector input[type="radio"]:checked').length > 0) {
                        $('.addressSelector input[type="radio"]:checked').attr('data-state-code', data.Province);
                    }
                } else {
                    $('#address1').val(data.Line1);
                    $('#address2').val(data.Line2 || data.Line3 || '');
                    $('#city').val(data.City);
                    $('#zipCode').val(data.PostalCode);
                    $('#state').val(data.Province).trigger('chosen:updated');
                }
            }
            $.spinner().stop();
        })
        .fail(function () {
            $.spinner().stop();
        });
}

function showAddressValidationSuggestion (shippingAddressObject, suggestedAddress, isRecurrentFlow) {
    const modalContent = $('#shippingAddresSuggestionModal');
    var addressInsetedContent = '<div class="cc-shipping-address-content-on-modal">' +
        '<input id="addressInsertedByUser" name="shipping-address-radio"' +
        'type="radio" class="hidden form-check-input js-select-shipping-address-on-modal"' +
        'data-type="inserted" checked value="insertedByUser"' +
        '/>' +
        '<p>' + (shippingAddressObject.address1 || '') + (shippingAddressObject.address2 && shippingAddressObject.address2 !== '' ? ' ' + shippingAddressObject.address2 : '') +
            (shippingAddressObject.postalCode ? ' - ' + shippingAddressObject.postalCode : '') +
            (shippingAddressObject.city ? ' - ' + shippingAddressObject.city : '') + (shippingAddressObject.stateCode ? ' - ' + shippingAddressObject.stateCode : '') + '</p>' +
    '</div>';

    // Inject the content into the modal
    modalContent.find('#addressValidationInsertedContent').html(addressInsetedContent);
    if (suggestedAddress) {
        modalContent.find('.js-address-found, .js-select-shipping-address-suggested').removeClass('hide');
        modalContent.find('.js-address-not-found').addClass('hide');
        modalContent.find('.js-confirm-validation-btn').removeClass('disabled');
        modalContent.find('.js-confirm-validation-btn').removeClass('cc-shippingAddress-button_notfound');
        modalContent.find('.js-select-shipping-address-suggested').addClass('selected');
        modalContent.find('.js-confirm-validation-btn').removeClass('disabled');
        modalContent.find('.js-shippingAddress').removeClass('cc-notSuggestedAddress');

        var addressSuggestedContent = '<div class="cc-shipping-address-content-on-modal">' +
            '<input id="addressSuggested" name="shipping-address-radio"' +
                'type="radio" class="hidden form-check-input"' +
                'data-type="inserted" value="addressSuggested"' +
                'data-address1="' + (suggestedAddress.Address1 || '') + '"' +
                'data-postalcode="' + (suggestedAddress.PostalCode || '') + '"' +
                'data-city="' + (suggestedAddress.Locality || '') + '"' +
                'data-statecode="' + (suggestedAddress.AdministrativeArea || '') + '"' +
            '/>' +
            '<p>' + (suggestedAddress.Address1 || '') +
                (suggestedAddress.PostalCode ? ' - ' + suggestedAddress.PostalCode : '') +
                (suggestedAddress.Locality ? ' - ' + suggestedAddress.Locality : '') + (suggestedAddress.AdministrativeArea ? ' - ' + suggestedAddress.AdministrativeArea : '')  + '</p>' +
        '</div>';

        // Inject the content into the modal
        modalContent.find('#addressValidationSuggestedContent').html(addressSuggestedContent);
    } else {
        modalContent.find('.js-address-found, .js-select-shipping-address-suggested').addClass('hide');
        modalContent.find('.js-address-not-found').removeClass('hide');
        modalContent.find('.js-confirm-validation-btn').addClass('disabled');
        modalContent.find('.js-confirm-validation-btn').addClass('cc-shippingAddress-button_notfound');
        modalContent.find('.js-shippingAddress').addClass('cc-notSuggestedAddress');
    }

    // create and open confirmation modal
    const modal = newModalFromString(modalContent.html(), false, ['cc-address-suggestion-modal']);
    modal.open();
    $(modal.modalBox).addClass('cc-address-suggestion-modal-box');
    $(modal.modalBoxContent).addClass('cc-address-suggestion-modal-box-content');
    // Add event listeners for buttons
    $(modal.modalBox).on('click', '.close, .js-change-validation-btn', function () {
        if (!isRecurrentFlow) {
            $('body').trigger('checkout:addressSuggestionChangeManually');
        }
        modal.close();
        modal.destroy();
    });

    $(modal.modalBox).on('click', '.js-confirm-validation-btn:not(.disabled)', function () {
        var data = {};
        if ($('.js-select-shipping-address-on-modal.selected').data('type') === 'suggested') {
            var radioSelected = $('.js-select-shipping-address-on-modal.selected').find('input[type=radio]');
            data = {
                address1: radioSelected.data('address1'),
                address2: '',
                city: radioSelected.data('city'),
                postalCode: radioSelected.data('postalcode'),
                stateCode: radioSelected.data('statecode')
            };
        }
        data.modaltype = $('.js-select-shipping-address-on-modal.selected').data('type');
        data.isRecurrentSuggestion = isRecurrentFlow;
        $('body').trigger('checkout:updateSuggestedAddress', data);
        modal.close();
        modal.destroy();
    });
}

function prepareAddressValidationSuggestion () {
    var suggestedAddress;
    if ($('#addressSuggestedRecurrent').length) {
        suggestedAddress = {
            Address1: $('#addressSuggestedRecurrent').data('address1'),
            PostalCode: $('#addressSuggestedRecurrent').data('postalcode'),
            Locality: $('#addressSuggestedRecurrent').data('city'),
            AdministrativeArea: $('#addressSuggestedRecurrent').data('statecode')
        };
    }
    const shippingAddressObject = {
        address1: $('#addressInsertedByUserRecurrent').data('address1'),
        address2: $('#addressInsertedByUserRecurrent').data('address2'),
        postalCode: $('#addressInsertedByUserRecurrent').data('postalcode'),
        city: $('#addressInsertedByUserRecurrent').data('city'),
        stateCode: $('#addressInsertedByUserRecurrent').data('statecode')
    };
    showAddressValidationSuggestion(shippingAddressObject, suggestedAddress, true);
}

module.exports = {
    methods: {
        updateShippingAddressSelector: updateShippingAddressSelector,
        updateShippingAddressFormValues: updateShippingAddressFormValues,
        updateShippingSummaryInformation: updateShippingSummaryInformation,
        updatePLIShippingSummaryInformation: updatePLIShippingSummaryInformation,
        updateProductLineItemShipmentUUIDs: updateProductLineItemShipmentUUIDs,
        updateShippingInformation: updateShippingInformation,
        updateMultiShipInformation: updateMultiShipInformation,
        shippingFormResponse: shippingFormResponse,
        toggleMultiShip: toggleMultiShip,
        createNewShipment: createNewShipment,
        selectShippingMethodAjax: selectShippingMethodAjax,
        updateShippingMethodList: updateShippingMethodList,
        shippingSelectionResponse: shippingSelectionResponse,
        checkIfDeliveryAddressShouldBeHidden: checkIfDeliveryAddressShouldBeHidden,
        showAddressForm: showAddressForm,
        hideAddressForm: hideAddressForm,
        hideAddressFormForGiftcard: hideAddressFormForGiftcard,
        setMandatoryBilling: setMandatoryBilling,
        resetBillingState: resetBillingState,
        clearInputFields: clearInputFields,
        prepareAddressValidationSuggestion: prepareAddressValidationSuggestion
    },

    selectShippingMethod: function () {
        $(document).on('click', '.js-shipping-types', function () {
            if (!$(this).hasClass('shipping-method-selected') && !$(this).hasClass('js-shipping-types-express')) {
                var $shippingForm = $(this).parents('form');
                var methodID = $(this).find('.js-shipping-method').val();
                $('.error-message.generic').hide();
                $(this).find('.js-shipping-method').prop('checked', true);
                var shipmentUUID = $shippingForm.find('[name=shipmentUUID]').val();
                var urlParams = addressHelpers.methods.getAddressFieldsFromUI($shippingForm);
                urlParams.shipmentUUID = shipmentUUID;
                urlParams.methodID = methodID;
                urlParams.isGift = ($('[name^=wrapquantity]').val() > 0).toString() || false;
                urlParams.giftMessage = $('.js-gift-message').val();
                var url = $(this).closest('.shipping-method-list').data('select-shipping-method-url');
                selectShippingMethodAjax(url, urlParams);
            }
        });

        $(document).on('keydown', '.js-shipping-types', function (e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13 || keyCode === 32) {
                e.preventDefault();
                $(this).trigger('click');
            }
        });
    },

    updateViewAfterChangeShippingMethod: function () {
        checkIfDeliveryAddressShouldBeHidden();
        $(document).on('shipping:updateShippingInformation', function (evt, data) {
            // $('#shippingAddressForm').prepend($('.shipping-address-block'));
            $('.shipping-address-block').removeClass('hidden');
            const shipment = data.shipping;
            var stepShippingCompleted = $('.shipping-form').attr('data-checkout-stage-completed');
            var isPickupEnabled = shipment.selectedShippingMethod.pointPickupEnabled;
            if (isPickupEnabled) {
                var pickupChosen = $('.js-shipping-type-' + shipment.selectedShippingMethod.ID).prop('data-pickupchosen') || false;
                $('.js-shipping-types:not(.js-shipping-type-' + shipment.selectedShippingMethod.ID + ')').prop('data-pickupchosen', 'false');
                stepShippingCompleted = $('.shipping-form').attr('data-checkout-stage-completed') == 'true' && pickupChosen;
                stepShippingCompleted = stepShippingCompleted ? 'true' : 'false';
            }
            $('#expressButtonModal').attr('data-modal-stage', 'shipping');
            if (stepShippingCompleted === 'false') {
                $('input[name$=storeId]').remove();
                $('.js-select-store').css('display', 'inline-block');
                $('.shipping-form .js-change-store').hide();
                $('.selectedStoreRecap').hide();
                if (shipment.selectedShippingMethod.pointPickupEnabled) {
                    hideAddressForm('pup', data.step);
                    setMandatoryBilling();
                    // Hide default shipping's form when PUP flow is selected. Apply only for UA
                    if ($('.getNovaPoshtaSettlement').length > 0) {
                        hideAddressForm('pup');
                    }
                } else {
                    // Remove previous selection for pickup point
                    $('.shipping-form #pickUpPointNumber').remove();
                    $('.shipping-form #pickUpPointName').remove();
                    $('.shipping-form #pickUpPointAddress1').remove();
                    $('.shipping-form #pickUpPointCity').remove();
                    $('.shipping-form #pickUpPointPostalCode').remove();
                    $('.selectedPickupPointRecap').hide();
                    $('.shipping-form .js-select-point').attr('style', '');
                    $('.shipping-form .js-change-point').attr('style', 'display: none');
                    $('.selectedSwissPostPickupPointRecap').hide();
                    $('.shipping-form .js-select-swiss-point').attr('style', '');
                    $('.shipping-form .js-change-swiss-point').attr('style', 'display: none');
                    $('.selectedExpressOnePickupPointRecap').addClass('hide');
                    $('.shipping-form .js-select-eo-pup').removeClass('hide');
                    $('.selectedPickupRecapBRT').addClass('hide');
                    $('.js-select-pickup-BRT').removeClass('hide');
                    $('.selectedPickupRecapBPOST').addClass('hide');
                    $('.js-select-pickup-BPOST').removeClass('hide');
                    $('.selectedPickupRecapPDB').addClass('hide');
                    $('.js-select-pickup-PDB').removeClass('hide');
                    $('.cc-selectedPickupRecap').addClass('hide');
                    $('.js-select-pickup-EVR').removeClass('hide');
                    $('.js-select-pickup-PTN').removeClass('hide');
                    $('.js-select-pickup-EST').removeClass('hide');
                    $('.js-select-pickup-DEL').removeClass('hide');
                    $('.js-select-pickup-CTT').removeClass('hide');
                    $('.js-select-pickup-GLS').removeClass('hide');
                    $('.js-select-pickup-MRE').removeClass('hide');
                    $('.js-select-pickup-GLSHU').removeClass('hide');
                    $('.js-select-pickup-DPD').removeClass('hide');
                    $('.js-select-pickup-SPS').removeClass('hide');
                    $('.selectedPickupRecapFAN').addClass('hide');
                    $('.js-select-pickup-FAN').removeClass('hide');
                    $('.js-select-pickup-XBS').removeClass('hide');
                    $('.js-select-pickup-POSTAT').removeClass('hide');
                    $('.selectedNovaPoshtaPickupRecap').addClass('hide');
                    $('.shipping-form .np-first-selection-btn').removeClass('hide');
                }
                if (shipment.selectedShippingMethod.storePickupEnabled) {
                    setMandatoryBilling();
                }
                if (shipment.selectedShippingMethod.storePickupEnabled || shipment.selectedShippingMethod.pointPickupEnabled) {
                    $('.next-step-button').find('.submit-shipping').prop('disabled', true);
                    $('.js-expressButtonContinue').prop('disabled', true);
                    $('.selectedPickupRecapBRT').addClass('hide');
                    $('.js-select-pickup-BRT').removeClass('hide');
                    $('.selectedPickupRecapBPOST').addClass('hide');
                    $('.js-select-pickup-BPOST').removeClass('hide');
                    $('.selectedPickupRecapPDB').addClass('hide');
                    $('.js-select-pickup-PDB').removeClass('hide');
                    $('.cc-selectedPickupRecap').addClass('hide');
                    $('.js-select-pickup-EVR').removeClass('hide');
                    $('.js-select-pickup-PTN').removeClass('hide');
                    $('.js-select-pickup-EST').removeClass('hide');
                    $('.js-select-pickup-DEL').removeClass('hide');
                    $('.js-select-pickup-CTT').removeClass('hide');
                    $('.js-select-pickup-GLS').removeClass('hide');
                    $('.js-select-pickup-MRE').removeClass('hide');
                    $('.js-select-pickup-GLSHU').removeClass('hide');
                    $('.js-select-pickup-DPD').removeClass('hide');
                    $('.js-select-pickup-SPS').removeClass('hide');
                    $('.selectedPickupRecapFAN').addClass('hide');
                    $('.js-select-pickup-FAN').removeClass('hide');
                    $('.js-select-pickup-XBS').removeClass('hide');
                    $('.js-select-pickup-POSTAT').removeClass('hide');

                } else {
                    $('.next-step-button').find('.submit-shipping').prop('disabled', false);
                    $('.js-expressButtonContinue').prop('disabled', false);
                }
            } else {
                if ($('.data-checkout-stage').data('customer-type') === 'guest' && data.options && data.options.selectMethodStep && $('.isSmartGift').val() === 'false') {
                    clearInputFields();
                }
                if (shipment.selectedShippingMethod.storePickupEnabled) {
                    hideAddressForm('pickup');
                    setMandatoryBilling();
                } else if (shipment.selectedShippingMethod.pointPickupEnabled) {
                    hideAddressForm('pup', data.step);
                    setMandatoryBilling();
                } else if (shipment.selectedShippingMethod.isElectronicShipping) {
                    hideAddressFormForGiftcard();
                    setMandatoryBilling();
                } else {
                    showAddressForm(data.step);
                    resetBillingState();
                }
            }
            let shippingMethodId = shipment.selectedShippingMethod.ID;
            $('.js-shipping-types').removeClass('shop-selected');
            $('.js-shipping-types').removeClass('shipping-method-selected');
            $('.js-shipping-type-' + shippingMethodId).addClass('shipping-method-selected');
            enableExpressButton(shipment, data);

            let storeName;
            let storeAddress;
            let storeCity;
            let postalCode;
            let selectedStoreSap;
            let type;
            let serviceType;
            if (shipment.selectedShippingMethod.storePickupEnabled || shipment.selectedShippingMethod.pointPickupEnabled) {
                $('.js-shipping-type-' + shippingMethodId).addClass('shop-selected');
            }

            if (shipment.selectedShippingMethod.ID === 'CZPP2T' || shipment.selectedShippingMethod.ID === 'PPLPT') {
                storeName = $('.js-pickup-name-PPL').data('info') || null;
                storeAddress = $('.js-pickup-address1-PPL').data('info') || null;
                storeCity = $('.js-pickup-address2-PPL').data('info') || null;
                postalCode = $('.js-pickup-postalcode-PPL').data('info') || null;
                selectedStoreSap = $('.js-pickup-sap-PPL').data('info') || null;

                if (storeName && storeAddress && storeCity && postalCode && selectedStoreSap) {
                    const data = {
                        name: storeName,
                        address1: storeAddress,
                        city: storeCity,
                        postalCode: postalCode,
                        sap: selectedStoreSap
                    };

                    $('body').trigger('PPL:selectedPickup', data);
                }
            }
            if (shipment.selectedShippingMethod.ID === 'FRCOLPT') {
                storeName = $('.js-pickup-name-CLSS').data('info') || null;
                storeAddress = $('.js-pickup-address1-CLSS').data('info') || null;
                storeCity = $('.js-pickup-address2-CLSS').data('info') || null;
                postalCode = $('.js-pickup-postalcode-CLSS').data('info') || null;
                selectedStoreSap = $('.js-pickup-sap-CLSS').data('info') || null;
                type = $('.js-pickup-type-CLSS').data('info') || null;

                if (storeName && storeAddress && storeCity && postalCode && selectedStoreSap) {
                    const data = {
                        name: storeName,
                        address1: storeAddress,
                        city: storeCity,
                        postalCode: postalCode,
                        sap: selectedStoreSap,
                        type: type

                    };

                    $('body').trigger('CLSS:selectedPickup', data);
                }
            }
            if (shipment.selectedShippingMethod.ID === 'DEPP2T') {
                storeName = $('.js-pickup-name-DHL').data('info') || null;
                storeAddress = $('.js-pickup-address1-DHL').data('info') || null;
                storeCity = $('.js-pickup-address2-DHL').data('info') || null;
                postalCode = $('.js-pickup-postalcode-DHL').data('info') || null;
                selectedStoreSap = $('.js-pickup-sap-DHL').data('info') || null;

                if (storeName && storeAddress && storeCity && postalCode && selectedStoreSap) {
                    const data = {
                        name: storeName,
                        address1: storeAddress,
                        city: storeCity,
                        postalCode: postalCode,
                        sap: selectedStoreSap
                    };

                    $('body').trigger('DHL:selectedPickup', data);
                }
            }
            if (shipment.selectedShippingMethod.ID === 'PLPP2T') {
                storeName = $('.js-pickup-name-DPD').data('info') || null;
                storeAddress = $('.js-pickup-address1-DPD').data('info') || null;
                storeCity = $('.js-pickup-address2-DPD').data('info') || null;
                postalCode = $('.js-pickup-postalcode-DPD').data('info') || null;
                selectedStoreSap = $('.js-pickup-sap-DPD').data('info') || null;

                if (storeName && storeAddress && storeCity && postalCode && selectedStoreSap) {
                    const data = {
                        name: storeName,
                        address1: storeAddress,
                        city: storeCity,
                        postalCode: postalCode,
                        sap: selectedStoreSap
                    };

                    $('body').trigger('DPD:selectedPickup', data);
                }
            }
            if (shipment.selectedShippingMethod.shippingMethodType === 'SPS') {
                storeName = $('.js-pickup-name-SPS').data('info') || null;
                storeAddress = $('.js-pickup-address1-SPS').data('info') || null;
                storeCity = $('.js-pickup-address2-SPS').data('info') || null;
                postalCode = $('.js-pickup-postalcode-SPS').data('info') || null;
                selectedStoreSap = $('.js-pickup-sap-SPS').data('info') || null;

                if (storeName && storeAddress && storeCity && postalCode && selectedStoreSap) {
                    const data = {
                        name: storeName,
                        address1: storeAddress,
                        city: storeCity,
                        postalCode: postalCode,
                        sap: selectedStoreSap
                    };

                    $('body').trigger('SPS:selectedPickup', data);
                }
            }

            if (shipment.selectedShippingMethod.shippingMethodType === 'PDB') {
                storeName = $('.js-pickup-name-PDB').data('info') || null;
                storeAddress = $('.js-pickup-address1-PDB').data('info') || null;
                storeCity = $('.js-pickup-address2-PDB').data('info') || null;
                postalCode = $('.js-pickup-postalcode-PDB').data('info') || null;
                selectedStoreSap = $('.js-pickup-sap-PDB').data('info') || null;
                type = $('.js-pickup-type-PDB').data('info') || null;
                serviceType = $('.js-pickup-servicetype-PDB').data('info') || null;

                if (storeName && storeAddress && storeCity && postalCode && selectedStoreSap) {
                    const data = {
                        number: selectedStoreSap,
                        name: storeName,
                        address1: storeAddress,
                        city: storeCity,
                        postalCode: postalCode,
                        type: type,
                        serviceType: serviceType // PDB needs serviceType as pickupPointName to close the order
                    };

                    $('body').trigger('PDB:selectedPickup', data);
                }
            }

            if (['BPOST', 'EVR', 'PTN', 'EST', 'DEL', 'GLS', 'MRE', 'GLSHU', 'DPD', 'SPS', 'FAN', 'XBS', 'CTT', 'POSTAT'].indexOf(shipment.selectedShippingMethod.shippingMethodType) !== -1) {
                var shippingMethodType = shipment.selectedShippingMethod.shippingMethodType;
                storeName = $('.js-pickup-name-' + shippingMethodType).data('info') || null;
                storeAddress = $('.js-pickup-address1-' + shippingMethodType).data('info') || null;
                storeCity = $('.js-pickup-address2-' + shippingMethodType).data('info') || null;
                postalCode = $('.js-pickup-postalcode-' + shippingMethodType).data('info') || null;
                selectedStoreSap = $('.js-pickup-sap-' + shippingMethodType).data('info') || null;
                type = $('.js-pickup-type-' + shippingMethodType).data('info') || null;

                if (storeName && storeAddress && storeCity && postalCode && selectedStoreSap) {
                    const data = {
                        number: selectedStoreSap,
                        name: storeName,
                        address1: storeAddress,
                        city: storeCity,
                        postalCode: postalCode,
                        type: type
                    };

                    $('body').trigger('STANDARD:selectedPickup', data);
                }
            }

            $('.selectedPickupRecapHermes').addClass('hide');
            $('.js-select-pickup-hermes').removeClass('hide');
        });
    },

    selectMultiShipping: function () {
        $('input[name="usingMultiShipping"]').on('change', function () {
            var checked = this.checked;
            toggleMultiShip(checked);
        });
    },

    selectSingleShipAddress: function () {
        $('.single-shipping .addressSelector input').on('change', function () {
            const form = $(this).parents('form')[0];
            const $selectedOption = $(this);
            const attrs = $selectedOption.data();
            const shipmentUUID = $selectedOption[0].value;
            const originalUUID = $('input[name=shipmentUUID]', form).val();

            Object.keys(attrs).forEach(function (attr) {
                let element = attr === 'countryCode' ? 'country' : attr;
                $('.shipping-address [name$=' + element + ']', form).val(attrs[attr]);
            });

            $('.shipping-address [name$=stateCode]', form).trigger('change').trigger('chosen:updated');

            if (shipmentUUID === 'new') {
                var $form = $(this).closest('form');
                $form.find('.is-invalid').removeClass('is-invalid');
                $form.find('.invalid-feedback').hide().text('');
                $(form).attr('data-address-mode', 'new');
                $('.shipping-address-block').addClass('hidden');
                $(this).closest('.internal-container').append($('.shipping-address-block').removeClass('hidden'));
            } else if (shipmentUUID === originalUUID) {
                $(form).attr('data-address-mode', 'shipment');
            } else if (shipmentUUID.indexOf('ab_') === 0) {
                $(form).attr('data-address-mode', 'customer');
            } else {
                $(form).attr('data-address-mode', 'edit');
            }
            // without this, HK users won't be able to add a ne address at checkout
            // the zipcode field will be empty and not editable
            if ($('.shippingZipCode').attr('value') !== '' && $('.shippingZipCode').val() === '' && $('#country-code').val() === 'HK') {
                $('.shippingZipCode').val($('.shippingZipCode').attr('value'));
            }
        });
    },

    selectMultiShipAddress: function () {
        $('.product-shipping-block .addressSelector').on('change', function () {
            var form = $(this).parents('form')[0];
            var selectedOption = $('option:selected', this);
            var attrs = selectedOption.data();
            var shipmentUUID = selectedOption[0].value;
            var originalUUID = $('input[name=shipmentUUID]', form).val();
            var pliUUID = $('input[name=productLineItemUUID]', form).val();

            Object.keys(attrs).forEach(function (attr) {
                $('[name$=' + attr + ']', form).val(attrs[attr]);
            });

            if (shipmentUUID === 'new' && pliUUID) {
                var createShipmentUrl = $(this).attr('data-create-shipment-url');
                createNewShipment(createShipmentUrl, { productLineItemUUID: pliUUID })
                    .done(function (response) {
                        $.spinner().stop();
                        if (response.error) {
                            if (response.redirectUrl) {
                                window.location.href = response.redirectUrl;
                            }
                            return;
                        }

                        $('body').trigger('checkout:updateCheckoutView',
                            {
                                order: response.order,
                                customer: response.customer,
                                options: { keepOpen: true }
                            }
                        );

                        $(form).attr('data-address-mode', 'new');
                    })
                    .fail(function () {
                        $.spinner().stop();
                    });
            } else if (shipmentUUID === originalUUID) {
                $('select[name$=stateCode]', form).trigger('change');
                $(form).attr('data-address-mode', 'shipment');
            } else if (shipmentUUID.indexOf('ab_') === 0) {
                var url = form.action;
                var serializedData = $(form).serialize();
                createNewShipment(url, serializedData)
                    .done(function (response) {
                        $.spinner().stop();
                        if (response.error) {
                            if (response.redirectUrl) {
                                window.location.href = response.redirectUrl;
                            }
                            return;
                        }

                        $('body').trigger('checkout:updateCheckoutView',
                            {
                                order: response.order,
                                customer: response.customer,
                                options: { keepOpen: true }
                            }
                        );

                        $(form).attr('data-address-mode', 'customer');
                    })
                    .fail(function () {
                        $.spinner().stop();
                    });
            } else {
                var updatePLIShipmentUrl = $(form).attr('action');
                var serializedAddress = $(form).serialize();
                createNewShipment(updatePLIShipmentUrl, serializedAddress)
                    .done(function (response) {
                        $.spinner().stop();
                        if (response.error) {
                            if (response.redirectUrl) {
                                window.location.href = response.redirectUrl;
                            }
                            return;
                        }

                        $('body').trigger('checkout:updateCheckoutView',
                            {
                                order: response.order,
                                customer: response.customer,
                                options: { keepOpen: true }
                            }
                        );

                        $(form).attr('data-address-mode', 'edit');
                    })
                    .fail(function () {
                        $.spinner().stop();
                    });
            }
        });
    },

    // Select city based on input zip code
    selectCityByZipCode: function () {
        $('body').on('input', '.grZipCode', function (e) {
            e.stopImmediatePropagation();
            updateStateSelectMenu();
        });

        $('body').on('input', '.grShippingZipCode', function (e) {
            e.stopImmediatePropagation();
            updateStateSelectMenu('shipping');
        });

        $('body').on('input', '.grBillingZipCode', function (e) {
            e.stopImmediatePropagation();
            updateStateSelectMenu('billing');
        });

        function updateStateSelectMenu (section = '') {
            var section = section.charAt(0).toUpperCase() + section.slice(1);
            var currentZipCode = $('.gr' + section + 'ZipCode').val();
            var zipCodeFormat = /^\d{3}\s?\d{2}$/; // Zip code format must be 5 characters long with an optional space (123 45 or 12345)

            if (zipCodeFormat.test(currentZipCode)) {
                var url = $('.gr' + section + 'ZipCode').data('url');

                $.spinner().start();
                $.ajax({
                    url: url,
                    method: 'GET',
                    data: {
                        selectMenu: '.gr' + section + 'State',
                        zipCode: currentZipCode
                    },
                    success: function (data) {
                        if (data.stateSFID) {
                            $(data.selectMenu).val(data.stateSFID).trigger('chosen:updated');
                        }
                    }
                }).then(function () {
                    $.spinner().stop();
                });
            }
        }
    },

    changeCountry: function () {
        $('body').on('change', 'select.shippingCountry', function (e) {
            e.preventDefault();
            var url = $(e.currentTarget).data('url');
            var selectedCountryId = $(this).find('option:selected').attr('value');
            if (!selectedCountryId) {
                return;
            }
            let currentCountryShipping = $('.currentCountryShipping').val();
            $('body').trigger('checkout:changeCountry', {
                previousCountry: currentCountryShipping,
                newCountry: selectedCountryId
            });
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'get',
                data: {selectedCountryId: selectedCountryId},
                success: data => {
                    if (data) {
                        $('.changeCountryModalContainer').html(data);
                        const htmlContent = $('#changeCountryModal').html();

                        const onClose = () => {
                            $('body').trigger('checkout:changeCountry', {
                                action: 'back_to_the_website',
                                previousCountry: currentCountryShipping,
                                newCountry: selectedCountryId
                            });
                            $('select.shippingCountry').val(currentCountryShipping).trigger('chosen:updated');
                        };

                        // create and open confirmation modal
                        const modal = newModalFromString(htmlContent, false, [], null, onClose);
                        $(modal.modalBox).addClass('change-country-modal');
                        modal.open();

                        $(modal.modalBox).on('click', '.close, .change-country-return-btn', function () {
                            $('body').trigger('checkout:changeCountry', {
                                action: 'back_to_the_website',
                                previousCountry: currentCountryShipping,
                                newCountry: selectedCountryId
                            });
                            $('select.shippingCountry').val(currentCountryShipping).trigger('chosen:updated');
                            modal.close();
                            modal.destroy();
                        });
                        $(modal.modalBox).on('click', '.change-country-confirmation-btn', function () {
                            $('body').trigger('checkout:changeCountry', {
                                action: 'proceed',
                                previousCountry: currentCountryShipping,
                                newCountry: selectedCountryId
                            });
                        });
                        $.spinner().stop();
                    }
                },
                error: function () {
                    $('select.shippingCountry').val(currentCountryShipping).trigger('chosen:updated');
                    $.spinner().stop();
                }
            });
        });
    },

    emailDomainValidation: function () {
        EmailDomainValidation.run('#shippingEmail', '.unknown-email-domain');
    },

    /**
     * retrieve cities for the given input, as soon as the user fills minimum character
     */
    autocompleteShippingAddress: function () {
        $('input.shippingAddressAuto').each(function () {
            /**
             * Use debounce to avoid making an Ajax call on every single key press by waiting a few
             * hundred milliseconds before making the request. Without debounce, the user sees the
             * browser blink with every key press.
             */
            let debounceSuggestedAddress = debounce(getSuggestedAddress, 300);
            $(this).on('input', function (e) {
                debounceSuggestedAddress(this);
            });
            $('body').on('checkout:shippingAddressAutocompleteElement', function (_e, data) {
                const addressId = data.id;
                if (!addressId) return;
                const addressType = data.type;
                if (addressType && addressType.toLowerCase() === 'address') {
                    retrieveAddress(addressId);
                    $('#shipping_more_info').attr('style', '');
                    $('.shipping-form, .account-content [data-uuid="new"] .address-form').attr('data-shipping-suggestion-visible', 'false');
                } else {
                    getSuggestedAddress(this, addressId);
                }
            });
            if ($('#checkout-main').length > 0) {
                $('.js-add-address-manually').on('click', function () {
                    const shippingForm = $('#shippingAddressForm');
                    var fieldsToClear = ['address1', 'houseNumber', 'address2', 'city', 'postalCode'];
                    for (var i = 0; i < fieldsToClear.length; i++) {
                        var field = fieldsToClear[i];
                        $('input[name$=_' + field + ']', shippingForm).val('');
                    }
                    $('#shippingState', shippingForm).val('').trigger('chosen:updated');
                    $('#shipping_more_info', shippingForm).attr('style', '');
                    $('.shipping-form').attr('data-shipping-suggestion-visible', 'false');
                    $('#shipping_more_info').css({display: 'flex'});
                });
            } else {
                $('.js-add-address-manually').on('click', function () {
                    $('.account-content [data-uuid="new"] .address-form').attr('data-shipping-suggestion-visible', 'false');
                });
            }
        });
    },

    showSuggestionAddressModalMyAccount: function () {
        if ($('#checkout-main').length > 0) {
            return;
        }
        $('body').on('address:addressSuggestionShowModal', function (_e, data) {
            const addressInserted = data.addressInserted;
            const suggestedAddress = data.suggestedMatch;
            showAddressValidationSuggestion(addressInserted, suggestedAddress);
        });
    },

    clearServerSideErrorOnChange: function () {
        $('body').on('input', '.shipping-form .is-invalid', function () {
            var $field = $(this);
            $field.removeClass('is-invalid');
            $field.closest('.form-group').find('.invalid-feedback').hide();
        });
    }
};
